import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

export const FBTextFieldStyles = makeStyles<NextTheme>((theme) =>
  createStyles({
    textfield: ({ rows, customHeight, error }: { rows?: string | number, customHeight?: number, error?: boolean } = {}) => ({
      borderRadius: 3,
      '& .MuiOutlinedInput-root': {
        height: customHeight || 40,
        fontWeight: 400,
        fontSize: 14,
        borderColor: error ? Colors.error_red : Colors.light_gray_border,
        '&.MuiInputBase-multiline': {
          height: 'auto',
          padding: 0,
        },
        '& fieldset': {
          borderColor: Colors.light_gray_border,
          borderRadius: 3,
        },
      },
      '& .MuiOutlinedInput-input': {
        padding: '13px',
      },
    }),
    error: {
      '& .Mui-error': {
        fontSize: 11,
      },
    },
    preview: {
      marginLeft: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
    },
  }));
